import {
  PP_ERROR_COLOR,
  PP_INFO_COLOR,
  PP_SUCCESS_COLOR,
  PP_SYSTEM_COLOR,
  PP_WARNING_MAIN_COLOR,
  WHITE_COLOR,
} from '@/styles';

export const pageLevelBackgroundColor = {
  error: PP_ERROR_COLOR,
  info: PP_INFO_COLOR,
  success: PP_SUCCESS_COLOR,
  warning: PP_WARNING_MAIN_COLOR,
};

export const pageLevelTextColor = {
  error: WHITE_COLOR,
  info: PP_SYSTEM_COLOR,
  success: WHITE_COLOR,
  warning: PP_SYSTEM_COLOR,
};
